import store from "../../../../store";
import { has, have } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    let myRoleName = []
    store.state.resource.auth.info?.roles.forEach(userRole => { myRoleName.push(userRole.refRole.name)})
    return {
        canEdit: ({ props, record }) => {
            const roleEdit = myRoleName.find((d) => d === "EDIT_LICENSE_STATUS")
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canActionAssignMe" })) return false; // หากเจอ canActionAssignMe ให้ไปแก้ไขผ่านหน้างานของฉัน
            if (["draft", "waitModify", "waitArgueLawyer", "cancel", "waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "notApprove", "appeal"].includes(record.refStatus?.key) && ["EDIT_LICENSE_STATUS"].includes(roleEdit)) {
                result = true || result;
            }
            if ([undefined, "draft", "waitModify", "waitArgue", "notApprove"].includes(record.refStatus?.key)) {
                if (record.createBy === store.state.resource.auth.info.user?.username) {
                    result = true || result;
                }
            } else if (have({ menuContext, key: record.refStatus?.attribute['canActionAttribute'] })) {
                    result = true || result;
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canCancelRequest: ({ record }) => {
            let result = false;
            if (![undefined, "draft", "waitApprove", "approve", "notApprove", "appeal", "cancel"].includes(record.refStatus?.key)) {
                if (record.createBy === store.state.resource.auth.info.user?.username) {
                    result = true || result;
                }
            }
            return result;
        },
        canApproveCancelRequest: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forDofCenter" }) && record.isCancelRequest) {
                if (["waitDofCenterAudit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitFisheryOfficer: ({ record, props }) => {
            const { menuContext } = props;
            let result = false;
            if (["draft", "waitModify"].includes(record.refStatus?.key)) {
                if (record.createBy === store.state.resource.auth.info.user?.username && !record.isOfficerCreate ) {
                    result = true || result;
                }
                if(record.isOfficerCreate && has({ menuContext, key: "forSendRequest" })) {
                    result = true || result;
                }
            }
            return result;
        },
        canArgueLawyer: ({ record, props }) => {
            const { menuContext } = props;
            let result = false;
            if (["waitArgueLawyer"].includes(record.refStatus?.key)) {
                if (record.createBy === store.state.resource.auth.info.user?.username && !record.isOfficerCreate ) {
                    result = true || result;
                }
                if(record.isOfficerCreate && has({ menuContext, key: "forSendRequest" })) {
                    result = true || result;
                }
            }
            return result;
        },
        canConfirmResult: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            // const userInfo = store.state.resource.auth.info?.user;
            if (record.isActive === false) return false;
            if (has({ menuContext, key: "forReviewRequest" })) {
                if (["waitAcceptRequest"].includes(record.refStatus?.key) && record.refFisheriesOfficerStatus != null ) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forLawyerAuditor" })) {
                if (["waitLawyerAudit"].includes(record.refStatus?.key) && record.refLawyerStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forRDAuditor" })) {
                if (["waitRDAudit"].includes(record.refStatus?.key) && record.refRdStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forDofCenter" })) {
                if (["waitDofCenterAudit"].includes(record.refStatus?.key) && record.refDofCenterStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forAuthorized" }) && record.refDirectorStatus != null) {
                if (["waitApprove", "appeal"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canAppealRequest: ({ record }) => {
            let result = false;
            if (record.createBy === store.state.resource.auth.info.user?.username && record.isCanAppealRequest) {
                result = true || result;
            }
            return result;
        },
    };
};

export const createConditionForm = () => {
    return [

    ];
};

export const commonInputPropField = ({ disabledStatuses }) => ({ initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const commonComponentProp = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let canCreate = undefined;
    let canDelete = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
        canCreate = false;
        canDelete = false;
    }
    return { canCreate, canDelete };
};
